// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__ySwWs","wide":"Card_wide__NYgyc"};